module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1400.459a54b7.svg";